import { scoreInfo } from '../../../../helpers/assessment'
import { style } from '../../style'
import Detail from './detail'

export default class Measure extends Component {
  state = {selected: false}
  render() {
    const { selected } = this.state
    const { msr: {name, weight, id, display, msrs},
            assessment_type, msr, ob, last } = this.props
    const cardio = assessment_type._assessment_types.name === 'Cardio'
    const outcome = assessment_type._assessment_types.name === 'Outcome_Measures'
    const scoreOb = ob || this.scoreOb(id)
    const score = scoreOb && cardio ? ((scoreOb.score - 5) * 2.5) + 10 : (5 - scoreOb.score) * 2.5
    const percent = scoreOb &&
                    score * 10
    const assessInfo = scoreInfo(percent, assessment_type._assessment_types)

    if (display == "Multi") {
      return msr.msrs.map((msr, index) => {
        var ob = this.scoreOb(msr.id)
        return ob && <Measure
                       {...this.props}
                       ob={ob}
                       key={index}
                       msr={msr}
                       assessment_type={assessment_type} />})}

    return (
      <View style={last ? style.msrCard : [style.msrCard, style.msrBorder]}>
        <TouchableOpacity onPress={this.toggleSelected}>
          <View key={uniqueId()}>
            <View style={style.msrContainer}>
              <MeasureScore
                outcome={outcome}
                value={percent}
                thickness={6}
                backgroundColor={assessInfo.color}
                label={score}
              />
              <Text style={style.msrName}>{name}</Text>
            </View>
            <View>
              {this.state.selected &&
                <React.Fragment>
                  {this.props.msr.rationale && <Text style={{ fontSize: 12, color: 'gray', paddingLeft: 75 }}>{this.props.msr.rationale}</Text>}
                  <View style={style.msrDetails}>
                    <Detail
                      {...this.props}
                      color={assessInfo.color}
                      score={score} scoreOb={this.scoreOb}
                    />
                  </View>
                </React.Fragment>
              }
            </View>
          </View>
        </TouchableOpacity>
      </View>
    )
  }

  scoreOb = id => find(this.props.obs, { msr: { id }})

  toggleSelected = () => this.setState({selected: !this.state.selected})
}

class MeasureScore extends Component {
  render() {
    const {label='N/A', value, backgroundColor='#a0c96f', outcome} = this.props
    return (
      <View style={[style.scoreContainer, outcome ? { backgroundColor: 'gainsboro' } : { backgroundColor }]}>
        <Text style={style.scoreTxt}>{outcome ? 'N/A' : label}</Text>
      </View>
    )
  }
}
